import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// services
import { MessageService } from '../../services/message.service'
import { MasterService } from '../../services/master.service'
import { StoreService } from '../../services/store.service'
import { SecurityService } from 'src/app/services/security.service';
import { Subscription } from "rxjs";

@Component({
    selector: 'app-communication-center',
    templateUrl: './communication-center.component.html',
    styleUrls: ['./communication-center.component.scss'],
    standalone: false
})
export class CommunicationCenterComponent implements OnInit {
  /*
  * variables
  */
  private entity: string = ''
  private entityId: string = ''
  private data: string = ''

  // A handle to navbar event messages so we can unsubscribe later.
  private navbarWatcher: Subscription | null = null
  /*
  * Functions
  */

  constructor(private store: StoreService, private route: ActivatedRoute, private ms: MessageService, private master: MasterService, private security: SecurityService) {
    
    if (this.store.userAccount['capabilities']) {
      // if not have permissions, return to account settings
      if (this.security.permitted('contacts', 'notes alerts', 'view')) {
        this.entity = this.route.snapshot.params['entity']
        this.entityId = this.route.snapshot.params['entityId']
      }
      else{
        window.location.href = "#/profile"
      }
    }
    
    // listener    
    this.navbarWatcher = this.ms.channelComponents$.subscribe(res => {
      
      if (res.message == 'setPermissions' && res.value && res.value.indexOf('reports') >= 0) {
        // permissions on user list
        if (this.security.permitted('contacts', 'notes alerts', 'view')) {
          this.entity = this.route.snapshot.params['entity']
          this.entityId = this.route.snapshot.params['entityId']
        }
        else{
          window.location.href = "#/profile"
        }
      } 
    })
  }

  ngOnInit() {

  }

  ngOnDestroy() {
    if (!this.navbarWatcher) {
      return
    }

    this.navbarWatcher.unsubscribe()
  }

}
